import { ParcoursStubPage } from '../../../components/parcours/ParcoursStubPage';
import { getParcoursStub } from '../../../config/parcours-particuliers';

export default function AuditEnergetiquePage() {
  const parcours = getParcoursStub('audit-energetique');
  if (!parcours) return null;
  return <ParcoursStubPage parcours={parcours} />;
}
